// Emoji and their variation selector: decoration on screen, but a screen reader
// reads each one out by name ("smiling face with smiling eyes").
const PICTOGRAPHS = /[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}]\uFE0F?/gu;

/** `text` as a status announcement should sound: emoji dropped, spacing tidied. */
export const forSpeech = (text: string): string =>
  text
    .replace(PICTOGRAPHS, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
